import { render } from "./BattleLoad.vue?vue&type=template&id=7c2ce9c5"
import script from "./BattleLoad.vue?vue&type=script&lang=js"
export * from "./BattleLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__